import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import './App.css'
import LayoutPage from './components/layout'
// import { useEffect } from 'react';
import LoginPage from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import ForgotPassword from './components/forgotPassword';
import ResetPassword from './components/resetPassword';
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS
import {Spin} from 'antd';
import { useLoaderStore } from './util/useLoaderStore';


function App() {

  const loading = useLoaderStore((state) => state.loading);
  
  return (
    <Router>
        <Spin spinning={loading} tip="Loading..." size="large">
            {/* ToastContainer for global toast notifications */}
      
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      <Routes>
       {/* Public Route: Login */}
       <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />
        <Route
                  path="/reset-password"
                  element={
                    <PublicRoute>
                      <ResetPassword />
                    </PublicRoute>
                  }
                />


         {/* Protected Route: Layout */}
         <Route
          path="/*"
          element={
            <ProtectedRoute>
              <LayoutPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      </Spin>
    </Router>
  )
}

export default App
